/**
 * @desc 箱子绑定交货单
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.Response;
export function request(boxCode: string, dono: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierBox/bindDono/${boxCode}/${dono}`, {
      method: "POST",

      ...options,
    }),
  );
}
